import { isFunction } from './isFunction.js';

function isAsyncIterable(obj) {
    return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

export { isAsyncIterable };
//# sourceMappingURL=isAsyncIterable.js.map
